import {HeadlineMedium, LogoGold, MainTitle} from 'ui';
import AwesomeSlider from 'react-awesome-slider';
import {SlideContainer, SlideText, ButtonWide, Container, SignupHint} from './styles';
import 'react-awesome-slider/dist/styles.css';
import 'ui/sass/awesomeSlider.sass';

import slide1 from 'assets/img/slide1.jpg';
import slide2 from 'assets/img/slide2.png';
import slide3 from 'assets/img/slide3.jpg';
import slide4 from 'assets/img/slide4.jpg';

const Slideshow = () => (
  <Container>
    <AwesomeSlider fillParent>
      <SlideContainer style={{backgroundImage: `url(${slide1})`}}>
        <LogoGold />
        <SlideText>
          <MainTitle>Devenez membre</MainTitle>
          <HeadlineMedium>
            Entrez dans un univers glacé réservé exclusivement aux professionnels et bénéficiez d’un
            accompagnement exclusif !
          </HeadlineMedium>
          <ButtonWide to="/login" color="white">
            Connexion
          </ButtonWide>
          <SignupHint>Pour vous inscrire, contactez votre commercial Carte&nbsp;d’Or.</SignupHint>
        </SlideText>
      </SlideContainer>
      <SlideContainer style={{backgroundImage: `url(${slide2})`}}>
        <LogoGold />
        <SlideText>
          <MainTitle>Des Recettes</MainTitle>
          <HeadlineMedium>
            Entrez dans un univers glacé réservé exclusivement aux professionnels et bénéficiez d’un
            accompagnement exclusif !
          </HeadlineMedium>
          <ButtonWide to="/login" color="white">
            Connexion
          </ButtonWide>
          <SignupHint>Pour vous inscrire, contactez votre commercial Carte&nbsp;d’Or.</SignupHint>
        </SlideText>
      </SlideContainer>
      <SlideContainer style={{backgroundImage: `url(${slide3})`}}>
        <LogoGold />
        <SlideText>
          <MainTitle>Des Exclusivités</MainTitle>
          <HeadlineMedium>
            Entrez dans un univers glacé réservé exclusivement aux professionnels et bénéficiez d’un
            accompagnement exclusif !
          </HeadlineMedium>
          <ButtonWide to="/login" color="white">
            Connexion
          </ButtonWide>
          <SignupHint>Pour vous inscrire, contactez votre commercial Carte&nbsp;d’Or.</SignupHint>
        </SlideText>
      </SlideContainer>
      <SlideContainer style={{backgroundImage: `url(${slide4})`}}>
        <LogoGold />
        <SlideText>
          <MainTitle>Des Cadeaux</MainTitle>
          <HeadlineMedium>
            Entrez dans un univers glacé réservé exclusivement aux professionnels et bénéficiez d’un
            accompagnement exclusif !
          </HeadlineMedium>
          <ButtonWide to="/login" color="white">
            Connexion
          </ButtonWide>
          <SignupHint>Pour vous inscrire, contactez votre commercial Carte&nbsp;d’Or.</SignupHint>
        </SlideText>
      </SlideContainer>
    </AwesomeSlider>
  </Container>
);

export default Slideshow;
